import { render } from "./TypePanel.vue?vue&type=template&id=968551ba&scoped=true&ts=true"
import script from "./TypePanel.vue?vue&type=script&lang=ts"
export * from "./TypePanel.vue?vue&type=script&lang=ts"

import "./TypePanel.vue?vue&type=style&index=0&id=968551ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968551ba"]])

export default __exports__